/* eslint-disable react/require-default-props */
import React, {ReactNode} from 'react';
import {
  KeyboardAvoidingView as RNKeyboardAvoidingView,
  KeyboardAvoidingViewProps,
  ViewStyle,
} from 'react-native';

import platformConfig from '/config/platform.config';

import {styles} from './KeyboardAvoidingView.style';

interface CustomKeyboardAvoidingViewProps extends KeyboardAvoidingViewProps {
  children?: ReactNode;
  style?: ViewStyle;
}

export const KeyboardAvoidingView: React.FC<
  CustomKeyboardAvoidingViewProps
> = ({children, style: styleProp, ...restProps}) => {
  const behavior: KeyboardAvoidingViewProps['behavior'] =
    platformConfig.getOS() === 'ios' ? 'padding' : undefined;

  const style = {...styles.base, ...(styleProp || {})};

  return (
    <RNKeyboardAvoidingView {...restProps} style={style} behavior={behavior}>
      {children}
    </RNKeyboardAvoidingView>
  );
};

export default KeyboardAvoidingView;
